var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Acciones", {
        on: {
          "firmar-pendientes": _vm.firmarPendientes,
          download: _vm.download,
          refresh: _vm.refresh,
        },
      }),
      _vm._v(" "),
      _c("section", { staticClass: "section p-4" }, [
        _c(
          "div",
          { staticClass: "columns" },
          [
            _c(
              "div",
              { staticClass: "column is-4 is-3-tablet is-3-desktop" },
              [
                _vm.$store.getters.hasAnyRole(["otros-admin"])
                  ? _c("Administrador", {
                      on: { selectScope: _vm.openSelectScopeModal },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ModalSeleccionarAlcance", {
                  attrs: { showModal: _vm.showModal },
                  on: {
                    "close-modal": _vm.closeModal,
                    "launch-firmador": _vm.launchFirmador,
                  },
                }),
                _vm._v(" "),
                _c("Filtros", {
                  on: { "set-query": _vm.setQuery, refresh: _vm.refresh },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                { staticClass: "box" },
                [_c("Listado", { ref: "listado" })],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.selectedDocumentos.length
              ? _c("MultipleSidebar", { on: { download: _vm.download } })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }